export const ControlType = {
    TEXT_FIELD: 'TEXT_FIELD',
    TEXT_AREA: 'TEXT_AREA',
    LABEL: 'LABEL',
    BUTTON: 'BUTTON',
    CHECKBOX: 'CHECKBOX',
    OPTION: 'OPTION'
}



// WEBPACK FOOTER //
// ./src/commons/ControlType.js